import { h, JSX } from 'preact'

import { Checkbox, CheckboxProps } from '../../components/forms/checkbox/checkbox'
import { Textfield, TextfieldProps } from '../../components/forms/textfield/textfield'

export interface ContactSectionProps {
    title?: string
    text?: string
    name: TextfieldProps
    email: TextfieldProps
    phone: TextfieldProps
    newsletter?: CheckboxProps
}

export const ContactSection = (props: ContactSectionProps): JSX.Element => (
    <div class="checkout__section">
        {props.title && <h2 class="checkout__section-title">{props.title}</h2>}
        {props.text && <div class="checkout__section-text">{props.text}</div>}
        <div class="checkout__section-content">
            <Textfield class="checkout__field" {...props.name} />
            <Textfield class="checkout__field" {...props.email} />
            <Textfield class="checkout__field" {...props.phone} />
            {props.newsletter && <Checkbox {...props.newsletter} />}
        </div>
    </div>
)
